import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import SecondaryButton from '../common/SecondaryButton';
import PostCard from '../blog/PostCard';
import { PRIMARY_COLORS } from '../../common/colors';
import posts from '../../data/posts.json';

// Webflow section_blog55: light-brand section, "Get to know the community"
// header + the three latest post cards from the generated manifest.

const BlogHighlights = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ backgroundColor: PRIMARY_COLORS['95'] }}>
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { md: 'center' },
            gap: 3,
            mb: { xs: 5, md: 6 },
          }}>
          <Box>
            <Typography sx={{ color: 'primary.main', fontWeight: 600, mb: 1 }}>
              {t('home.blog_highlights.eyebrow')}
            </Typography>
            <Typography variant="h3" component="h2" sx={{ color: 'surface.dark', fontSize: { xs: '2rem', md: '2.5rem' }, mb: 1 }}>
              {t('home.blog_highlights.heading')}
            </Typography>
            <Typography sx={{ color: 'surface.contrastText' }}>
              {t('home.blog_highlights.text')}
            </Typography>
          </Box>
          <SecondaryButton to="/blog" sx={{ alignSelf: { xs: 'flex-start', md: 'center' } }}>
            {t('common.view_all')}
          </SecondaryButton>
        </Box>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 4 }}>
          {posts.slice(0, 3).map(post => <PostCard key={post.slug} post={post} />)}
        </Box>
      </Container>
    </Box>
  );
};

export default BlogHighlights;
